/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import { faPaperPlane } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from 'react-i18next';
import dayjs from 'dayjs';
import { StatusDetails } from './StatusDetails';
import { antragsZeit } from '@/domain/arbeitszeiten/entities/Arbeitszeit';
import { getAntragsArt } from './AntragsArt';

export function AntragInfoText({
  beginn,
  ende,
  beginnAZ,
  endeAZ,
  erstellungsdatum,
  offen,
  mitarbeiter,
}: {
  beginn?: antragsZeit;
  ende?: antragsZeit;
  beginnAZ?: antragsZeit;
  endeAZ?: antragsZeit;
  aenderungsdatum?: Date;
  erstellungsdatum?: Date;
  offen?: boolean;
  mitarbeiter?: { vorname: string; nachname: string };
}) {
  const antragsArt = getAntragsArt(beginn, ende);
  return (
    <div className="flex flex-col text-sm text-black font-semibold whitespace-nowrap">
      <div className="flex items-center gap-2 font-semibold rounded-full justify-between">
        <div
          className={`flex items-center gap-1 ${offen ? 'pb-3 pt-2' : 'pt-3'}`}>
          {offen && (
            <FontAwesomeIcon
              icon={faPaperPlane}
              size={`${offen ? 'lg' : 'sm'}`}
              className={offen ? 'text-primary-blue-B600 pe-2' : ''}
            />
          )}
          <Trans
            i18nKey="domain.arbeitszeiten.sheet.antraege.art"
            values={{ antragsArt }}
            components={{
              1: <span />,
            }}
          />
        </div>
        {erstellungsdatum && (
          <div className="text-sm font-normal text-neutrals-N600 mt-3">
            {`${dayjs(erstellungsdatum)
              .locale('de')
              .format('dd., DD. MMMM, HH:mm')} Uhr`}
          </div>
        )}
      </div>

      <div>
        {!offen && (
          <StatusDetails
            beginn={beginn?.time ?? beginnAZ?.time}
            ende={ende?.time ?? endeAZ?.time}
            mitarbeiter={mitarbeiter}
          />
        )}
      </div>
    </div>
  );
}
